export default __webpack_public_path__ + "static/media/pdf.d12a45de.svg";